<div class="loader__overlay">
  <div class="loader__wrapper">
    <mat-spinner></mat-spinner>
  </div>
</div>
